"use client";

import type { HeaderLogoProps } from "./types/header-logo.types";
import { AnimatePresence, motion } from "motion/react";
import { easeSpring } from "../../utils/easings";

import { headerLogoStyles, headerLogoIconStyles, headerLogoWordmarkStyles } from "./styles/header-logo.styles";

export const HeaderLogo: React.FC<HeaderLogoProps> = (props) => {
  const { children, ref, className, title, ...rest } = props;
  return (
    <div className="flex-1 grid-contain relative place-items-start">
      <AnimatePresence initial={false} mode="popLayout">
        <motion.div
          key={title}
          ref={ref}
          className={headerLogoStyles({ className })}
          initial={{ opacity: 0, y: 1 }}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              ...easeSpring,
              delay: 0.15,
            },
          }}
          exit={{ opacity: 0, y: -1 }}
          transition={easeSpring}
          {...rest}
        >
          <div className={headerLogoIconStyles()}>{children}</div>
          {title ? <div className={headerLogoWordmarkStyles()}>{title}</div> : null}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

HeaderLogo.displayName = "HeaderLogo";
